module.exports = __webpack_public_path__ + "static/media/Diffuse_N.d2f7ff78.jpg";